import {
  Box,
  styled
} from '@mui/material';

import React from 'react';
import SiriusMainLogo from '../../icons/siriusMainLogo.svg'; //release branch

//import CVXMainLogo from '../../icons/cvxMainLogo.svg'; // release-ship branch



const LogoWrapper = styled(Box)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);
 
function Logo() { 
  return (
    <LogoWrapper> 
      <img src={SiriusMainLogo} alt='main_logo' height={'139.3px'}  />
      {/* <img src={CVXMainLogo} alt='main_logo' height={'109.3px'} width={'100px'}/> */}  
    </LogoWrapper>
  );
}

export default Logo;
